$(document).ready(function() {

	$('body').on('submit', '.js-validate-form', function(e) {

		if (e.isDefaultPrevented()) {
			// handle the invalid form...
		} else {
			$('.newslatter-btn').prop('disabled', true);
			var fields = $(".js-validate-form .form-control");

			$.ajax({
				type: "POST",
				url: $('.js-validate-form').attr('action'),
				data: $('.js-validate-form').serialize(),
				dataType: 'json',
				success: function(data) {
					if (data.status == "success") {

						// $('.js-validate-form .msg-success').removeClass('hidden');
						$('.js-validate-form input:not(.js-validate-form--send)').val("");
						$('.newslatter-btn').prop('disabled', false);

						$.each(fields, function(index, elem) {
							$(elem).next('.with-errors').text('');
						})

						$('.js-validate-form').append('<div style="color: #000; text-align: center; font-size: 20px; font-weight: 600;" class="js-validate-form-text-after-sending-form">' + data.text_end + '</div>');

						setTimeout(function() {
							// $('.js-validate-form .msg-success').addClass('hidden');
							$('.js-validate-form-text-after-sending-form').remove();
						}, 3000);
					} else {

						var fields_db = [];
						$.each(fields, function(index, elem) {
							fields_db.push($(elem).attr('name'));
						})

						var errorsArr = Object.keys(data.errors);
						for (var i = 0; i < fields_db.length; i++) {
							for (var j = 0; j < errorsArr.length; j++) {
								if (fields_db[i].includes(errorsArr[j])) {
									$.each(fields, function(index, elem) {
										if (elem.name === fields_db[i]) {
											$(elem).parent().removeClass('has-success').addClass('has-error has-danger');
											$(elem).next('.with-errors').text(data.errors[errorsArr[j]]);
										}
									})
								}
							}
						}

						$('.newslatter-btn').prop('disabled', false);

					}
				}
			});
		}
		return false;
	});

});